import { render } from "./takeover.vue?vue&type=template&id=e846dfaa&lang=pug"
import script from "./takeover.vue?vue&type=script&lang=js"
export * from "./takeover.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__